import { PAYMENT_ROLES, Role } from 'constants/roles';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { AutocompleteMultiselectInput, TextInput } from 'shared/react-admin/Inputs';
import { ReferenceArrayInput } from 'shared/react-admin/ReferenceInputs';

export const MerchantShowAccessListFilterForm: React.FC = () => {
  const translate = useTypedTranslate();

  return (
    <>
      <TextInput
        helperText={false}
        key="user.firstName"
        label={translate('app.merchantAccess.firstName')}
        name="user.firstName"
        source="user.firstName"
        variant="outlined"
      />
      <TextInput
        helperText={false}
        key="user.lastName"
        label={translate('app.merchantAccess.lastName')}
        name="user.lastName"
        source="user.lastName"
        variant="outlined"
      />
      <ReferenceArrayInput
        filter={{
          alias: [...PAYMENT_ROLES, Role.Risk, Role.Observer],
        }}
        perPage={100}
        reference="roles"
        source="user.roleEntities"
      >
        <AutocompleteMultiselectInput
          helperText={false}
          label={translate('app.filter.roles')}
          name="user.roleEntities"
          optionText="name"
          size="small"
        />
      </ReferenceArrayInput>
    </>
  );
};
